export default "__VITE_ASSET__BoGQEUal__"